import { render } from "./Regl.vue?vue&type=template&id=27f90322"
import script from "./Regl.vue?vue&type=script&lang=js"
export * from "./Regl.vue?vue&type=script&lang=js"

import "./Regl.vue?vue&type=style&index=0&id=27f90322&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__